import APIClient from './index';

export const getPrivateOfferReviewQueue = params => APIClient.get('Offers/review_queue', { params }).then(response => response.data);
export const reviewPrivateOffer = (offer, input) =>
  APIClient.post(`Offers/for_brand/${offer.Brand_id}/${offer.id}/review`, input).then(response => response.data);
export const refreshPrivateOfferAudienceEstimates = Brand_id =>
  APIClient.post(`Offers/review_estimates/${Brand_id}`).then(response => response.data);
